// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function incidental_charge_encode(v) {
  return Js_dict.fromArray([
              [
                "incidental_charge_id",
                Decco.intToJson(v.incidental_charge_id)
              ],
              [
                "amount",
                Decco.floatToJson(v.amount)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "crn",
                Decco.stringToJson(v.crn)
              ],
              [
                "start_time",
                Decco.floatToJson(v.start_time)
              ],
              [
                "end_time",
                Decco.floatToJson(v.end_time)
              ],
              [
                "waiting_time",
                Decco.floatToJson(v.waiting_time)
              ],
              [
                "restricted_time",
                Decco.floatToJson(v.restricted_time)
              ],
              [
                "toll",
                Decco.floatToJson(v.toll)
              ],
              [
                "travel_distance",
                Decco.floatToJson(v.travel_distance)
              ],
              [
                "is_return_trip",
                Decco.optionToJson(Decco.boolToJson, v.is_return_trip)
              ],
              [
                "road_tax",
                Decco.optionToJson(Decco.floatToJson, v.road_tax)
              ],
              [
                "environmental_tax",
                Decco.optionToJson(Decco.floatToJson, v.environmental_tax)
              ],
              [
                "up_entry_charge",
                Decco.optionToJson(Decco.floatToJson, v.up_entry_charge)
              ],
              [
                "incidental_charges",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(incidental_charge_encode, param);
                      }), v.incidental_charges)
              ],
              [
                "has_waypoints",
                Decco.optionToJson(Decco.boolToJson, v.has_waypoints)
              ],
              [
                "from_state_id",
                Decco.optionToJson(Decco.intToJson, v.from_state_id)
              ],
              [
                "to_state_id",
                Decco.optionToJson(Decco.intToJson, v.to_state_id)
              ],
              [
                "travel_duration",
                Decco.optionToJson(Decco.floatToJson, v.travel_duration)
              ]
            ]);
}

export {
  incidental_charge_encode ,
  t_encode ,
  
}
/* No side effect */
